import React, {useEffect, useState} from 'react'
import {
    Card,
    Chip, Grid,
    CardActionArea,
    CardContent, Box,
    Typography
} from "@mui/material";
import {useGetTemplatesByTypeQuery} from "../../../../../services/Template/templateSlice";
import CreateTemplateButton from '../../../TemplateTab/CreateTemplateButton';
import Loading from '../../../../../layout/Loading';
import {CheckCircle} from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import {selectTemplateDetails} from '../../../../../services/Template/templateClientSlice';
import {getModuleTypeColor, modulePackageName} from "../../../../../utils/displayUtils";
import {resolveModuleType} from "../../../../../config/moduleTypes";

const TemplateCard = ({moduleType, selectedTemplateId, activeModuleIndex, moduleId}) => {
    // Used to be 5 hardcoded useGetXTemplatesQuery() calls plus a 5-way if/else picking which
    // result was "the" active templates list — ending in
    // `throw new Error("Not yet implemented " + moduleType)` for anything else, which crashed
    // this whole tab if a 6th module type ever reached it. Now a single parameterized hook
    // (skipped entirely for an unrecognized type) — see config/moduleTypes.js.
    const type = moduleType ? resolveModuleType(moduleType) : undefined;
    const {data: templates, isLoading: templatesLoading} = useGetTemplatesByTypeQuery(
        type?.key,
        {skip: !type}
    );
    const dispatch = useDispatch();

    if (!moduleType) return null;

    if (!type) {
        console.warn(`TemplateCard: unrecognized module type "${moduleType}" — no templates to show.`);
        return null;
    }

    const handleClick = (template) => {
        handleSelectTemplate(activeModuleIndex, {
            moduleId: moduleId,
            patientCount: template.patientCount,
            testApprovalPercentage: template.testApprovalPercentage,
            generalSuccessPercentage: template.generalSuccessPercentage,
            trainingIsActive: template.trainingIsActive,
            testIsActive: template.testIsActive,
            theoryIsActive: template.theoryIsActive,
            name: template.name,
            id: template.templateId,
        });
    }

    const handleSelectTemplate = (moduleId, templateDetails) => {
        dispatch(selectTemplateDetails(moduleId, templateDetails));
    };

    return (
        <Grid container spacing={1.5} sx={{overflowY: "auto", maxHeight: "500px"}}>
            {
                templatesLoading ?
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center"
                         sx={{height: '300px', width: '500px'}}>
                        <Loading size={30} color={"#5177b8"}/>
                        <Typography sx={{mt: 2}} variant="body2" color='secondary'> Laster inn malene…</Typography>
                    </Box> : (
                        <>
                            <Grid item xl={3} lg={4} md={5} sm={6}>
                                <CreateTemplateButton fontHeader={12} width={190} height={180}/>
                            </Grid>
                            {templates?.data.map((template, index) => (
                                <Grid item key={index} sx={{mb: 2}} xl={3} lg={4} md={5} sm={6}>
                                    <Card sx={{width: 180, height: 180}}>

                                        <CardActionArea onClick={() => handleClick(template)}>
                                            <CardContent>
                                                <Chip
                                                    label={`${modulePackageName(moduleType)}`}
                                                    sx={{
                                                        backgroundColor: `${getModuleTypeColor(moduleType)}`,
                                                        color: '#fff',
                                                        fontSize: 11,
                                                    }}
                                                />
                                                <Typography sx={{fontWeight: 600, color: "#616161", my: 1, fontSize: 13}}>
                                                    {template.name}
                                                </Typography>
                                                <Typography variant="caption" display="block" gutterBottom>
                                                    Mal: {template.trainingIsActive ? "Trening  " : ""}{template.testIsActive ? "Test  " : ""}{template.theoryIsActive ? "Teori" : ""}
                                                </Typography>
                                                <Typography variant="caption"
                                                            sx={{whiteSpace: "pre-line", fontSize: 11, color: "#757575"}}>
                                                    {template.trainingIsActive && (
                                                        type.support.trainingPercentage
                                                            ? `Krav til godkjent trening: ${template.generalSuccessPercentage}%\n`
                                                            : `Besvarelsen blir enten godkjent / ikke godkjent.`
                                                    )}
                                                    {template.testIsActive &&
                                                        `Krav til godkjent test: ${template.testApprovalPercentage}%\n`
                                                    }
                                                    {template.patientCount &&
                                                        `Antall pasienter: ${template.patientCount}`
                                                    }
                                                </Typography>
                                            </CardContent>

                                            {selectedTemplateId === template.templateId && (
                                                <CheckCircle color="success"
                                                             sx={{position: 'absolute', bottom: 5, right: 5}}/>
                                            )}

                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </>
                    )
            }
        </Grid>
    )
}

export default TemplateCard;
